import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { domoEmbeds, createdDomoEmbed } from '../mockData/domo-embeds';

const DomoEmbedsApi = [
  rest.get(`${API_ROOT}domo`, (req, res, ctx) => {
    const limit = req.url.searchParams.get('limit');
    const offset = req.url.searchParams.get('offset');
    if (limit === '10' && offset === '0') {
      return res(ctx.json(domoEmbeds));
    }
    return res(ctx.json({ data: [], count: 0 }));
  }),

  rest.post(`${API_ROOT}domo/`, (req, res, ctx) => res(ctx.json(createdDomoEmbed))),
  rest.put(`${API_ROOT}domo/${domoEmbeds.rows[0].id}`, (req, res, ctx) => res(ctx.json([domoEmbeds.rows[0].id]))),
  rest.delete(`${API_ROOT}domo/${domoEmbeds.rows[0].id}`, (req, res, ctx) => res(ctx.json(true))),

  rest.get(`${API_ROOT}domo/${domoEmbeds.rows[0].id}`, (req, res, ctx) => res(ctx.json(domoEmbeds.rows[0]))),
];
export default DomoEmbedsApi;
